module.exports = __webpack_public_path__ + "media/images/haircut/card-mobile@2x-26114f332bb420d64f8029a2f5bc0f8f.jpg";